import { API_BASE_URL } from '../config';
import api from './axiosInstance';

export async function getDailyStateHomeCached(filters) {
  const cache = sessionStorage.getItem('dailyStateCache');

  if (cache) {
    const parsed = JSON.parse(cache);

    if (JSON.stringify(parsed.filters) === JSON.stringify(filters)) {
      return parsed.data;
    }
  }

  const resp = await getDailyStateHome(filters);

  sessionStorage.setItem(
    'dailyStateCache',
    JSON.stringify({ filters, data: resp })
  );

  return resp;
}

export async function getDailyStateHome(filters) {
  try {
    const payload = { ...filters };
    if (
      payload.InternalStateStatus === undefined ||
      payload.InternalStateStatus === null ||
      payload.InternalStateStatus === ''
    ) {
      if (payload.IsActive !== undefined && payload.IsActive !== null) {
        payload.InternalStateStatus = payload.IsActive ? 'Activa' : 'Inactiva';
      }
    }
    if (payload.IsActive !== undefined) {
      delete payload.IsActive;
    }
    const response = await api.post(
      `${API_BASE_URL}/CasesSaas/GetDailyStateHomeByUserId`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener el Estado diario.';
    throw error;
  }
}

export async function getDailyStateCached(filters) {
  const cache = sessionStorage.getItem('dailyStateCache');

  if (cache) {
    const parsed = JSON.parse(cache);

    if (JSON.stringify(parsed.filters) === JSON.stringify(filters)) {
      return parsed.data;
    }
  }

  const resp = await getDailyState(filters);

  sessionStorage.setItem(
    'dailyStateCache',
    JSON.stringify({ filters, data: resp })
  );

  return resp;
}

export async function getDailyState(filters, options = {}) {
  try {
    const payload = { ...filters };
    if (
      payload.InternalStateStatus === undefined ||
      payload.InternalStateStatus === null ||
      payload.InternalStateStatus === ''
    ) {
      if (payload.IsActive !== undefined && payload.IsActive !== null) {
        payload.InternalStateStatus = payload.IsActive ? 'Activa' : 'Inactiva';
      }
    }
    if (payload.IsActive !== undefined) {
      delete payload.IsActive;
    }
    const response = await api.post(
      `${API_BASE_URL}/CasesSaas/GetDailyStateByUserId`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        signal: options.signal,
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener el Estado diario.';
    throw error;
  }
}

export async function getDailyStateLaboral(filters, options = {}) {
  try {
    const payload = { ...filters };
    if (
      payload.InternalStateStatus === undefined ||
      payload.InternalStateStatus === null ||
      payload.InternalStateStatus === ''
    ) {
      if (payload.IsActive !== undefined && payload.IsActive !== null) {
        payload.InternalStateStatus = payload.IsActive ? 'Activa' : 'Inactiva';
      }
    }
    if (payload.IsActive !== undefined) {
      delete payload.IsActive;
    }
    const response = await api.post(
      `${API_BASE_URL}/DailyStatementLaboralSaas/GetDailyStateLaboralByUserId`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        signal: options.signal,
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener el Estado diario.';
    throw error;
  }
}

export async function getTribunalesUsuarioED(idUsuario) {
  try {
    const params = {};
    if (idUsuario) {
      params.idUsuario = idUsuario;
    }

    const response = await api.get(
      `${API_BASE_URL}/General/GetTribunalesUsuarioED`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        params,
      }
    );
    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener los tribunales del usuario.';
    throw error;
  }
}

export async function getPagedDailyStateByUser(
  page = 1,
  pageSize = 10,
  search = null
) {
  try {
    const params = {
      page,
      pageSize,
      userId: search.UserId,
      search: search.SearchDailyState || '',
      role: search.Role || '',
      caseName: search.Case || '',
      courtId: search.Court || 0,
      startDate: search.StartDate || null,
      endDate: search.EndDate || null,
      myCases: search.MyCases || 'mis causas',
    };

    // Solo agregar SearchDailyState si tiene valor
    if (search && search?.SearchDailyState && search?.SearchDailyState.trim()) {
      params.search = search?.SearchDailyState.trim();
    }

    const response = await api.get('CasesSaas/DailyState/paged', {
      headers: {
        'Content-Type': 'application/json',
      },
      params,
    });

    return {
      page: response.data.page,
      pageSize: response.data.pageSize,
      total: response.data.total,
      dailyStates: response.data.data || [],
    };
  } catch (error) {
    console.error('getPagedDailyStateByUser failed:', error);
    console.error('Error details:', error.response?.data);
    error.customMessage = 'No se pudo obtener el listado de estados diarios.';
    throw error;
  }
}

export async function getDailyStateById(id) {
  try {
    const response = await api.post(
      `${API_BASE_URL}/CasesSaas/GetDailyStateByUserId/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener el Estado diario.';
    throw error;
  }
}

export async function getDailyStateByTuple(
  role,
  civilCourtCode,
  newCivilCourtCode,
  businessAreaId
) {
  try {
    const response = await api.get(
      `${API_BASE_URL}/CasesSaas/GetDailyStateByTuple`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        params: { role, civilCourtCode, newCivilCourtCode, businessAreaId },
      }
    );
    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener el Estado diario.';
    throw error;
  }
}

export async function downloadFileS3(urlDocumento, nombreArchivo) {
  try {
    const response = await api.post(
      `${API_BASE_URL}/Pjud/DownloadFileS3/${urlDocumento}`,
      null,
      {
        responseType: 'blob',
      }
    );

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = nombreArchivo;
    link.click();

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error al descargar archivo:', error);
    throw error;
  }
}

export async function getFilePreviewUrlS3(urlDocumento) {
  try {
    const response = await api.post(
      `${API_BASE_URL}/Pjud/DownloadFileS3/${urlDocumento}`,
      null,
      {
        responseType: 'blob',
      }
    );

    // axios with responseType: 'blob' already returns a Blob
    const blob = response.data;
    const blobUrl = window.URL.createObjectURL(blob);

    return blobUrl;
  } catch (error) {
    console.error('Error al obtener vista previa del archivo:', error);
    throw error;
  }
}

export async function updateStatus(data, newState, userId) {
  try {
    const payload = {
      dailyStateId: data.dailyStateId,
      internalStatusId: newState,
      dailyStateDate: data.date,
      caseId: data.caseId,
      role: data.code,
      newCivilCourtCode: data.newCivilCourtCode,
      userId: userId,
    };

    const response = await api.post(
      'DailyStateInternalStatus/UpdateStatus',
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    return response.data;
  } catch (error) {
    console.error('updateStatus failed:', error);
    console.error('Error details:', error.response?.data);
    throw error;
  }
}

export async function exportDailyStatesExcel(params, signal) {
  try {
    const { page, pageSize, ...filters } = params;

    const queryObject = {
      page: 1,
      pageSize: 10000,
    };

    if (filters.SearchDailyState)
      queryObject.SearchDailyState = filters.SearchDailyState;

    if (filters.Role) queryObject.Role = filters.Role;
    if (filters.Case) queryObject.Case = filters.Case;
    if (filters.Client) queryObject.Client = filters.Client;
    if (filters.UserId) queryObject.UserId = filters.UserId;
    if (filters.MyCases) queryObject.MyCases = filters.MyCases;
    if (
      filters.InternalStateStatus !== undefined &&
      filters.InternalStateStatus !== null &&
      filters.InternalStateStatus !== ''
    ) {
      queryObject.InternalStateStatus = filters.InternalStateStatus;
    } else if (filters.IsActive !== undefined && filters.IsActive !== null) {
      queryObject.InternalStateStatus = filters.IsActive ? 'Activa' : 'Inactiva';
    }

    if (filters.sortKey) queryObject.SortBy = filters.sortKey;

    if (filters.sortDirection)
      queryObject.Desc = filters.sortDirection === 'desc';

    const paramsFinal = new URLSearchParams();

    for (const [key, value] of Object.entries({ ...queryObject, ...filters })) {
      if (Array.isArray(value)) {
        value.forEach((v) => paramsFinal.append(key, v));
      } else if (value !== undefined && value !== null) {
        paramsFinal.append(key, value);
      }
    }

    const response = await api.get('/CasesSaas/DailyStates/ExportExcel', {
      params: paramsFinal,
      responseType: 'blob',
      signal,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute(
      'download',
      `EstadosDiarios_${new Date().toISOString().split('T')[0]}.xlsx`
    );

    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error descargando Excel:', error);
    throw error;
  }
}
